import { type ReactNode } from 'react';

const TH =
  'whitespace-nowrap px-md py-sm text-[11px] font-medium uppercase tracking-wider text-text-tertiary/50';

const COLS = ['#', 'Username', 'Rol', 'Estado', 'Hoy', 'Racha', 'Acum.', ''];

export function ApproacherListHeader(): ReactNode {
  return (
    <thead>
      <tr className="border-b border-white/[0.06]">
        {COLS.map((c) => (
          <th key={c || 'actions'} className={TH}>
            {c}
          </th>
        ))}
      </tr>
    </thead>
  );
}
